module.exports = __webpack_public_path__ + "img/sfive.64566215.png";